module.exports = __webpack_public_path__ + "img/rajesh_h.b64e7c2c.png";